import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";

interface InfoWithLabelSkeletonProps {
  /**
   * Width of the content skeleton (e.g., "w-24", "w-40", "w-full")
   */
  contentWidth?: string;
  /**
   * Height of the content skeleton (e.g., "h-5", "h-6", "h-20")
   * Defaults to h-[1.75rem] to match bodyW1 (text-lg) line height
   */
  contentHeight?: string;
  fullWidth?: boolean;
  className?: string;
}

export const InfoWithLabelSkeleton = ({
  contentWidth = "w-24",
  contentHeight = "h-[1.75rem]",
  fullWidth = true,
  className,
}: InfoWithLabelSkeletonProps) => (
  <Stack gap="sm" fullWidth={fullWidth} className={className}>
    {/* Label skeleton - matches subtitleW3 (text-md font-semibold) height */}
    <Skeleton className="h-5 w-16" />
    {/* Content skeleton - matches bodyW1 (text-lg font-normal) height by default */}
    <Skeleton className={`${contentHeight} ${contentWidth}`} />
  </Stack>
);
